<ngx-loading [show]="loaded === null" />
<img
  #imgEl
  [src]="loaded === false ? default : (src ?? default)"
  [class]="'faded ' + imgClass"
  [class.fadein]="loaded !== null"
  [attr.width]="width"
  [attr.height]="height"
  [attr.alt]="alt"
/>
